import React from 'react';
import {
  MessageSquare,
  Calendar,
  BookOpen,
  Sparkles,
  PenTool,
  Bot,
  Brain,
} from "lucide-react";

const LeftSidebar = ({ activeTab, setActiveTab }) => {
  return (
    <div className="lg:col-span-3 space-y-6">
      {/* Navigation */}
      <div className="bg-white rounded-lg shadow">
        <div className="p-6">
          <nav className="space-y-2">
            <button
              className={`w-full flex items-center px-3 py-2 rounded-md text-left ${
                activeTab === 'feed' ? 'bg-gray-100' : 'hover:bg-gray-50'
              }`}
              onClick={() => setActiveTab('feed')}
            >
              <MessageSquare className="mr-2 h-4 w-4 flex-shrink-0" />
              <span className="truncate">Feed</span>
            </button>
            
            <button
              className={`w-full flex items-center px-3 py-2 rounded-md text-left ${
                activeTab === 'events' ? 'bg-gray-100' : 'hover:bg-gray-50'
              }`}
              onClick={() => setActiveTab('events')}
            >
              <Calendar className="mr-2 h-4 w-4 flex-shrink-0" />
              <span className="truncate">Events</span>
            </button>
            
            <button
              className={`w-full flex items-center px-3 py-2 rounded-md text-left ${
                activeTab === 'resources' ? 'bg-gray-100' : 'hover:bg-gray-50'
              }`}
              onClick={() => setActiveTab('resources')}
            >
              <BookOpen className="mr-2 h-4 w-4 flex-shrink-0" />
              <span className="truncate">Resources</span>
            </button>
          </nav>
        </div>
      </div>

      {/* AI Toolkit */}
      <div className="bg-gradient-to-br from-blue-50 to-indigo-50 border border-blue-200 rounded-lg shadow">
        <div className="pt-4 px-4 pb-2">
          <h3 className="text-lg font-semibold flex items-center">
            <Sparkles className="h-5 w-5 mr-2 text-blue-600 flex-shrink-0" />
            <span className="truncate">Ivy Club AI Toolkit</span>
          </h3>
        </div>
        
        <div className="p-4">
          <div className="space-y-3">
            <button
              className="w-full flex items-center justify-start px-3 py-2 border border-blue-200 rounded-md hover:bg-blue-50"
              onClick={() => window.open('#', '_blank')}
            >
              <PenTool className="mr-2 h-4 w-4 text-blue-600 flex-shrink-0" />
              <div className="text-left min-w-0">
                <div className="font-medium truncate">Ivy Club Essay Reviewer</div>
                <div className="text-xs text-gray-500 truncate">Get instant feedback on your essays</div>
              </div>
            </button>
            
            <button
              className="w-full flex items-center justify-start px-3 py-2 border border-blue-200 rounded-md hover:bg-blue-50"
              onClick={() => window.open('#', '_blank')}
            >
              <Bot className="mr-2 h-4 w-4 text-blue-600 flex-shrink-0" />
              <div className="text-left min-w-0">
                <div className="font-medium truncate">AI Writing Assistant</div>
                <div className="text-xs text-gray-500 truncate">Enhance your writing with AI</div>
              </div>
            </button>
            
            <button
              className="w-full flex items-center justify-start px-3 py-2 border border-blue-200 rounded-md hover:bg-blue-50"
              onClick={() => window.open('#', '_blank')}
            >
              <Brain className="mr-2 h-4 w-4 text-blue-600 flex-shrink-0" />
              <div className="text-left min-w-0">
                <div className="font-medium truncate">AI SAT Coach</div>
                <div className="text-xs text-gray-500 truncate">Personalized SAT prep guidance</div>
              </div>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LeftSidebar;